<template>
  <div>
    <!-- 配送单重新报价记录 -->
    <baseBreadcrumb :page="$t('message.requotationRecordOfDeliveryOrder')" :menu="$t('message.porder')" />
    <div class="search">
      <div class="operationContainer">
        <div class="leftContainer">
          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="datas.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 180px">
            </el-date-picker>
          </div>
          <!--   /配送单号-->
          <div class="item">
            <el-input v-model="datas.porder_sn" :placeholder="$t('message.deliveryNoteNumber')" class="Container"
              onfocus="this.select()" />
          </div>

          <!-- 客户ID-->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.clientID')" class="Container"
              onfocus="this.select()" />
          </div>
        </div>
        <div class="rightContainer"></div>
      </div>
      <div class="operationContainer">
        <div class="leftContainer">
          <!--人员范围-->
          <div class="item">
            <!--  人员范围-->
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!--  全部人员-->
            <el-select v-model="datas.created_by" :placeholder="$t('message.allPersonnel')" filterable clearable>
              <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="item">
            <!--  回退原因-->
            <el-select v-model="datas.reason" :placeholder="$t('message.reasonForBackOff')" filterable clearable>
              <el-option v-for="item in backReasonOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>

          <div class="item">
            <!--  搜索 -->
            <el-button type="primary" @click="search">{{
              $t("message.search")
            }}</el-button>

          </div>
        </div>
        <div class="rightContainer">
          <!-- 回退原因设置 -->
          <el-button type="primary" class="primary" @click="$refs.backoffReasonSetting.dialogVisible = true">{{
            $t("message.backoffReasonSetting")
          }}</el-button>

          <!-- 回退收费名义设置 -->
          <el-button type="primary" class="primary" @click="$refs.backoffChargeNominalSetting.dialogVisible = true">{{
            $t("message.backoffChargeNominalSetting")
          }}</el-button>


        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="table">
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" size="mini">
        <el-table-column align="center" label="NO" prop="rowNumber" width="60">
        </el-table-column>
        <!--  回退重新报价时间-->
        <el-table-column align="center" :label="$t('message.backOffTheTimeOfReOffer')" prop="created_at">
        </el-table-column>
        <!--  配送单单号-->
        <el-table-column align="center" :label="$t('message.deliveryOrderNumber')" width="180">
          <template slot-scope="scope">
            <router-link :to="'/porderDetail?porder_sn=' + scope.row.porder_sn" target="_blank" class="a-link">
              {{ scope.row.porder_sn }}
            </router-link>
          </template>
        </el-table-column>
        <!--  客户名-->
        <el-table-column align="center" :label="$t('message.customerName')" prop="porder.user.realname">
        </el-table-column>
        <!--  回退人-->
        <el-table-column align="center" :label="$t('message.personOfReturn')" prop="created_admin.realname">
        </el-table-column>
        <!--  所在组织-->
        <el-table-column align="center" :label="$t('message.organizationOfAffiliation')">
          <template slot-scope="scope">
            {{ scope.row.created_admin.role[0].name }}
          </template>
        </el-table-column>
        <!--  配送单操作员-->
        <el-table-column align="center" :label="$t('message.deliveryOrderOperator')" prop="created_at">
          <template slot-scope="scope">
            <div class="template">
              <!-- 业务 -->
              <p>{{ $t('message.business') }}：{{ scope.row.porder.y_admin ? scope.row.porder.y_admin.realname : '' }}</p>
              <!-- 采购 -->
              <p>{{ $t('message.purchase') }}：{{ scope.row.porder.g_admin ? scope.row.porder.g_admin.realname : '' }}</p>
              <!-- 配货 -->
              <p>{{ $t('message.distribution') }}：{{ scope.row.porder.p_admin ? scope.row.porder.p_admin.realname : '' }}</p>
              <p>FBA：</p>
            </div>
          </template>
        </el-table-column>
        <!--  回退原因-->
        <el-table-column align="center" :label="$t('message.reasonForBackOff')" prop="reason">
        </el-table-column>
        <!--  国际运费是否回退-->
        <el-table-column align="center" :label="$t('message.whetherTheInternationalFreightIsRefunded')">
          <template slot-scope="scope">
            {{ scope.row.is_logistics_fee_refund == 1 ? '退' : '不退' }}
          </template>
        </el-table-column>
        <!--  图片备注-->
        <el-table-column align="center" :label="$t('message.photoNotes')" width="160">
          <template slot-scope="scope">
            <img :src="item" alt="" v-for="(item, index) in scope.row.images" :key="index"
              style="width: 60px;height:60px; margin: 5px  ;">
          </template>
        </el-table-column>
        <!--  回退原因说明-->
        <el-table-column align="center" :label="$t('message.theReasonForTheBackoffIsExplained')" prop="reason_desc">
        </el-table-column>
        <!--  费用变动明细-->
        <el-table-column align="center" :label="$t('message.detailsOfChangesInExpenses')">
          <template slot-scope="scope">
            <el-button type="text" @click="look(scope.row)">
              {{ $t('message.look') }}
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paginationContainer">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--配送单回退-回退原因设置  -->
    <backoffReasonSetting ref="backoffReasonSetting" />
    <!-- 回退收费名义设置  -->
    <backoffChargeNominalSetting ref="backoffChargeNominalSetting" />
    <!-- 查看明细 -->
    <requotationOfDeliveryOrder ref="requotationOfDeliveryOrder" :id="id" />
  </div>
</template>
<script>
import backoffReasonSetting from './conponents/backoffReasonSetting'
import backoffChargeNominalSetting from './conponents/backoffChargeNominalSetting'
import requotationOfDeliveryOrder from './conponents/requotationOfDeliveryOrder'
export default {
  components: {
    backoffReasonSetting,
    backoffChargeNominalSetting,
    requotationOfDeliveryOrder
  },
  data() {
    return {
      id: 0,
      datas: {
        order_sn: "",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        org_id: "",
        created_by: "",
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      userList: [],
      backReasonOptions: []
    };
  },
  created() {
    this.backList()
    this.backReasonList()
    this.$store.dispatch('getLogisticsList')
  },
  methods: {
    //列表
    backList() {
      this.$api.porderApi.backList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(res);
      })
    },
    // 回退原因
    backReasonList() {
      this.$api.porderApi.backReasonList(this.datas).then(res => {
        this.backReasonOptions = res.data
      })

    },
    search() {
      this.datas.page = 1
      this.backList()
    },
    // 人员范围
    setUserList(data) {
      this.userList = data.userList;
      this.datas.org_id = data.id;
      this.datas.admin_id = "";
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.backList()

    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.backList()

    },
    // 查看
    look(item) {
      this.id = item.id
      this.$refs.requotationOfDeliveryOrder.dialogVisible = true
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  /deep/.el-select {
    width: 217px;
  }

  /deep/.el-input__inner {
    width: 217px !important;
  }

  /deep/.el-date-editor {
    width: 217px !important;
  }
}

.operationContainer {
  display: flex;

  .leftContainer {
    flex: 7;

    .item {
      margin-right: 20px;
    }
  }

  .rightContainer {
    flex: 1;
  }
}

.table {
  margin: 20px 0;

  .template {
    width: 100%;
    text-align: left;
  }
}
</style>